




import { Component, Mixins, Prop } from "vue-property-decorator";
import { HisInformationTextValue } from "../../../domain/his/HisInformationValue";

@Component({
})
export default class HisTextItemComponent extends Mixins() {
  @Prop()
  source: HisInformationTextValue;

  get formattedValue(): string {
    if (this.source == null) { return ""; }
    
    return this.source.data.join(",");
  }
}
